/** Extra Rates */
export const EXTRA_RATE_VALUES: readonly number[] = [0, 1, 1.5, 2, 2.5, 3, 3.5, 4]
export const EXTRA_RATE_MULTIPLIER = 100
